import { render, staticRenderFns } from "./addwrapper.vue?vue&type=template&id=9ee96664&scoped=true&"
import script from "./addwrapper.vue?vue&type=script&lang=js&"
export * from "./addwrapper.vue?vue&type=script&lang=js&"
import style0 from "./addwrapper.vue?vue&type=style&index=0&id=9ee96664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee96664",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VDialog,VNavigationDrawer})
